/**
 * 
 * @param {*} actionType 
 * @param {*} percentage 
 * @param {*} value 
 * @returns Modified value by percentage and actionType
 */

// export default function modifyValueByPercentage (actionType,percentage,value) {
//     switch (actionType) {
//         case "increase-by":
//           // Convert the string to number
//           return Number(((value/100)*percentage + value)?.toFixed(2))
//         case "decrease-by":
//           return Number((value - (value/100)*percentage)?.toFixed(2))
//         default:
//           break;
//       }
// }

// export default function modifyValueByPercentage(actionType, percentage, value) {
//   switch (actionType) {
//     case "increase-by":
//       // Calculate the increase amount
//       const increaseAmount = (value / 100) * percentage;
//       // Add the increase amount to the original value
//       return Number((value + increaseAmount).toFixed(2));
//     case "decrease-by":
//       // Calculate the decrease amount
//       const decreaseAmount = (value / 100) * percentage;
//       // Subtract the decrease amount from the original value
//       return Number((value - decreaseAmount).toFixed(2));
//     default:
//       return value;
//   }
// }


/**
 * @param {*} cpcValue
 * @param {number} [minBid=1] Currency/marketplace minimum bid (default 1 for legacy callers).
 */
export function isValidCpcForCopy(cpcValue, minBid = 1) {
  const parsed = parseFloat(cpcValue);
  return Number.isFinite(parsed) && parsed >= minBid;
}

export function calculateAfterBid({
  selectedAction,
  valuePercentage,
  setAsValue,
  currentBid,
  cpcValue,
  minBid = 0,
}) {
  if (selectedAction === "set_bid_as") {
    const parsed = parseFloat(setAsValue);
    return isNaN(parsed) ? null : Number(parsed.toFixed(2));
  }
  if (selectedAction === "copy_cpc") {
    const parsed = parseFloat(cpcValue);
    // Return numeric CPC even when below min so bidRules validation can
    // show a clear "below minimum" error instead of a generic invalid message.
    if (!Number.isFinite(parsed)) {
      return null;
    }
    return Number(parsed.toFixed(2));
  }
  const result = modifyValueByPercentage(
    selectedAction,
    valuePercentage,
    currentBid ?? 0
  );
  if (!Number.isFinite(result)) return null;

  // Decrease % / absolute: floor at min instead of returning null / N/A.
  if (
    selectedAction === "decrease-by" ||
    selectedAction === "decrease-by-abs"
  ) {
    const floor = Number.isFinite(Number(minBid)) ? Number(minBid) : 0;
    return Math.max(result, floor);
  }

  return result > 0 ? result : null;
}

export default function modifyValueByPercentage(actionType, percentage, value) {
  const castedVal = Number(value);
  const castedPercentage = Number(percentage);
  const safeVal = Number.isFinite(castedVal) ? castedVal : 0;
  const safePercentage = Number.isFinite(castedPercentage) ? castedPercentage : 0;

  switch (actionType) {
    case "increase-by": {
      const increasedValue = safeVal + (safeVal * safePercentage) / 100;
      return Number(increasedValue.toFixed(2));
    }
    case "decrease-by": {
      const decreasedValue = safeVal - (safeVal * safePercentage) / 100;
      return Number(decreasedValue.toFixed(2));
    }
    case "increase-by-abs": {
      return Number((safeVal + safePercentage).toFixed(2));
    }
    case "decrease-by-abs": {
      const decreasedValueAbs = safeVal - safePercentage;
      return Number((decreasedValueAbs <= 0 ? 0 : decreasedValueAbs).toFixed(2));
    }
    default:
      return safeVal;
  }
}
